import React,{ useEffect, useState } from "react";
import DataLoader from "../DataLoader";
import client from "../../api";
import { useParams } from "react-router-dom";
import { notifyError, notifyErrorInBottom, notifySuccess } from "../../helper";

const SendingAccountBox = () => {
    const api = client();
    const {campaignID} = useParams('');
    const [overview,setOverview] = useState({});
    const [previousName,setPreviousName] = useState('');
    const [previousEmail,setPreviousEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [mailAccounts, setMailAccounts] = useState({});
    const [accountEmailAddress, setAccountEmailAddress] = useState('');
    const [accountName, setAccountName] = useState('');
    const [hasSmtp,setHasSmtp] = useState(false);
    const [useSmtpPrev,setUseSmtpPrev] = useState(false);
    const [useSmtp,setUseSmtp] = useState(false);

    

    const handleMailAccountChange = (emailId) => {
        const selectedEmailAccount = mailAccounts.find((row)=> row.id === emailId);
        if(selectedEmailAccount !== undefined){
            setAccountEmailAddress(selectedEmailAccount.id);
            setAccountName(selectedEmailAccount.name);  
            setHasSmtp(selectedEmailAccount.has_smtp);
        } else {
            setAccountEmailAddress('');
            setAccountName('');  
            setHasSmtp(false);
        }
    }

    const handleFullNameChange = async (name) => {
        setAccountName(name);
    }

    const handleInputChange = (is_smtp) => {
        setUseSmtp(is_smtp);        
    }

    const updatProfile = async () => {
        if(!accountEmailAddress.length){
            notifyErrorInBottom('Please Select Email Account');
        } else if(!accountName.length){
            notifyErrorInBottom('From Name field can not empty');
        } else if(accountName === previousName && accountEmailAddress === previousEmail && useSmtpPrev === useSmtp){
            notifyErrorInBottom('The field value is identical to the existing one. Update the field to continue.');
        } else {
            try{
                setLoading(true);
                const payload = {
                    "assigned_to": accountEmailAddress,
                    "assigned_to_name": accountName,
                    "use_smtp":useSmtp

                }
                const response = await api.post(`/v1/campaign/${campaignID}/mailAccount/update`, payload);
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Mail Account Name updated successfully');    
                    setLoading(false);
                    setTimeout(()=>{
                        window.location.reload();
                    },1500);
                }
            } catch (error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Unable to update Mail Account Name');
                setLoading(false);
            }
        }
    }

    useEffect(()=>{
        const controller = new AbortController();
        const getSendingAccountDetails = async () => {
            try{
                const response = await api.get(`/v1/campaign/${campaignID}/mailAccount/get`);
                const results = await api.get('/v1/mailAccount/list');

                if(results.status === 200 || results.status === 201){
                    setMailAccounts(results.data.data);
                }

                if(response.status === 200 || response.status === 201){
                    const data = response.data.data;
                    
                    if(data.status === 'deleted'){
                        setAccountEmailAddress('');
                        setPreviousEmail(''); 
                        setAccountName('');
                        setPreviousName('');
                        setHasSmtp(false);   
                    } else {
                        setAccountEmailAddress(data.assigned_to);
                        setPreviousEmail(data.assigned_to);
                        setHasSmtp(data.has_smtp);
                        if(data.assigned_to_name === ''){
                            const allAccounts = results.data.data;
                            const filterAccounts = allAccounts.find((row)=>row.id === data.assigned_to);
                            setAccountName(filterAccounts.name);
                            setPreviousName(filterAccounts.name);                            
                        } else {
                            setAccountName(data.assigned_to_name);
                            setPreviousName(data.assigned_to_name);                            
                        } 
                    }                                                       
                }
            } catch(error){
                console.log('error.message', error);
                if(error.status === 400) notifyError('Bad Request. Unable to fetch sending account details');
            }
        }
        getSendingAccountDetails();

        return () => {
          controller.abort(); // Cleanup on unmount
        };

    },[]);
    
   useEffect(()=>{
           const getCampaignPreview = async () => {
               try{
                   const response = await api.post('/v1/campaign/preview',{ campaign_id:campaignID });
                   if(response.status === 200 ||response.status === 201 ){
                    setUseSmtp(response?.data?.campaignPreview?.setting?.use_smtp);
                    setUseSmtpPrev(response?.data?.campaignPreview?.setting?.use_smtp);
                   }
               } catch(error){
                   console.log('error.message',error);
                   if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Preview');
               }
           }
           getCampaignPreview();
       },[]);
    
    return(<>
        {Object.keys(mailAccounts).length ? <div className="box">
            <div className="box-title">Sending account</div>
            <div className="box-form">
                <div className="field-wrap">
                    <label className="label-xs">From address</label>
                    <select 
                        className="selectbox" 
                        value={accountEmailAddress}
                        onChange={(e)=>handleMailAccountChange(e.target.value)}>
                            <option value="">Select mail account</option>
                            {mailAccounts && mailAccounts.map((row,i)=>(
                                <option key={i} value={row.id} data-name={row.name}>{row.email}</option>
                            ))} 
                    </select>
                </div>
                <div className="field-wrap">
                    <label className="label-xs">From name</label>
                    <input 
                        type="text" 
                        name="from-name" 
                        placeholder="Full Name" 
                        value={accountName} 
                        onChange={(e)=>{handleFullNameChange(e.target.value)}}
                        />
                </div>

                {hasSmtp ? <div className="field-wrap">                                
                    <label className="label-xs center" htmlFor="use-smtp"> 
                        <input 
                            type="checkbox" 
                            name="use_smtp" 
                            id="use-smtp" 
                            checked={useSmtp}
                            onChange={(e)=>{handleInputChange(e.target.checked)}}
                            />  Use SMTP 
                    </label>
                </div>:''}

            </div>
            <div className="box-action">
                <button 
                    disabled={loading}
                    className={loading ? "primary-btn button--loading":"primary-btn"}
                    onClick={()=>{updatProfile()}}
                    >
                        <span className="button--text">Save</span>
                </button>
            </div>
        </div> : <DataLoader/> }
        </>);
}

export default SendingAccountBox;